import { Button, Heading, Stack, Text } from '@chakra-ui/react';
import { AuthStage } from '../..';
import { Title } from '../../../../atoms/Title';

interface IProps {
  appClient: string;
  cognitoDomain: string;
  onLogout: () => void;
  setAuthStage: (stage: AuthStage) => void;
}

const SSOLogout = (props: IProps) => {
  const { setAuthStage } = props;

  const handleLoginRedirect = () => {
    setAuthStage(AuthStage.NONE);
    setTimeout(() => {
      window.location.href = window.location.origin;
    }, 2000);
  };

  const title = 'You have been logged out';

  return (
    <>
      <Title title={title} />

      <Heading as="h1" mb="6">
        {title}
      </Heading>

      <Text>Thank you for using CAS Shield</Text>

      <Stack>
        <Button onClick={handleLoginRedirect} size="lg" variant="solid">
          Click Here to Login
        </Button>
      </Stack>
    </>
  );
};

export default SSOLogout;
